import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
const H = ({
  children,
  type = 'pain'
}: {
  children: React.ReactNode;
  type?: 'pain' | 'positive';
}) => <span className={`font-bold ${type === 'pain' ? 'underline decoration-pain/40 decoration-2 underline-offset-2 text-pain/90' : 'underline decoration-solution/50 decoration-2 underline-offset-2 text-solution'}`} data-id="element-175">
    {children}
  </span>;
const allItems: {
  content: React.ReactNode;
  type: 'pain' | 'positive';
}[] = [{
  content: <>
        You reach for Tylenol or NyQuil every single time — not because you want
        to, but because you <H data-id="element-176">don't know what else to do</H>.
      </>,
  type: 'pain'
}, {
  content: <>
        You've searched online for natural remedies and walked away more
        confused than when you started — too many opinions,{' '}
        <H data-id="element-177">zero clear answers</H>.
      </>,
  type: 'pain'
}, {
  content: <>
        You bought herbs or supplements before and they're{' '}
        <H data-id="element-178">still sitting in your cabinet</H> because nobody told you how to
        actually use them.
      </>,
  type: 'pain'
}, {
  content: <>
        You feel helpless at 2am when your kid is sick, you don't want to run to
        CVS, but you have <H data-id="element-179">no plan B</H>.
      </>,
  type: 'pain'
}, {
  content: <>
        You want to live more naturally but every resource you find is either
        too expensive, <H data-id="element-180">too complicated</H>, or written for someone with a
        pharmacy degree.
      </>,
  type: 'pain'
}, {
  content: <>
        You're exhausted by a system that profits from your dependency — and
        you're ready to <H data-id="element-181">take your family's health back</H> into your own
        hands.
      </>,
  type: 'pain'
}, {
  content: <>
        You're done guessing — and you're ready to finally have{' '}
        <H type="positive" data-id="element-182">a real plan</H>.
      </>,
  type: 'positive'
}, {
  content: <>
        You want <H type="positive" data-id="element-183">one trusted resource</H> your whole family
        can count on.
      </>,
  type: 'positive'
}];
export function PainPoints() {
  return <section className="py-8 md:py-14 bg-white" data-id="element-184">
      <div className="max-w-3xl mx-auto px-4" data-id="element-185">
        {/* Decorative divider */}
        <div className="flex items-center justify-center mb-4 md:mb-6" data-id="element-186">
          <div className="h-px w-16 bg-gray-300" data-id="element-187"></div>
          <div className="w-2 h-2 rounded-full bg-gray-300 mx-3" data-id="element-188"></div>
          <div className="h-px w-16 bg-gray-300" data-id="element-189"></div>
        </div>

        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-5 md:mb-8" data-id="element-190">
          THIS IS FOR YOU IF…
        </h2>

        {/* Zigzag list */}
        <div className="flex flex-col gap-2" data-id="element-191">
          {allItems.map((item, index) => {
          const borderLeft = index % 2 === 0;
          const isPositive = item.type === 'positive';
          const bgColor = isPositive ? 'bg-solution/8' : 'bg-pain/6';
          const borderColor = isPositive ? 'border-solution' : 'border-pain/70';
          const alignClass = index % 2 === 1 ? 'ml-auto' : 'mr-auto';
          return <div key={index} className={`w-[92%] md:w-[88%] ${alignClass}`} data-id="element-192">
                <div className={`flex items-start gap-2.5 rounded-md ${bgColor} px-3 py-2 md:px-4 md:py-2.5 ${borderLeft ? `border-l-[3px] ${borderColor}` : `border-r-[3px] ${borderColor}`} ${isPositive ? 'py-2.5 md:py-3' : ''}`} data-id="element-193">
                  {isPositive ? <CheckCircleIcon className="w-[18px] h-[18px] text-solution flex-shrink-0 mt-[3px]" data-id="element-194" /> : <XCircleIcon className="w-[18px] h-[18px] text-pain/70 flex-shrink-0 mt-[3px]" data-id="element-195" />}
                  <p className={`leading-snug ${isPositive ? 'text-primary font-semibold text-[0.94rem] md:text-base' : 'text-dark/80 text-[0.84rem] md:text-sm'}`} data-id="element-196">
                    {item.content}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}